import React, { useRef, useEffect } from 'react'
import useAnalysis from 'hooks/useAnalysis'

import Img from 'components/Img'
import Share from 'components/Share'

const Top = () => {
  const { start } = useAnalysis()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    ref.current?.scrollIntoView()
  }, [])

  return (
    <div ref={ref}>
      <div className="lg:max-w-[916px] lg:mx-auto">
        <Img
          src="img-top-1.jpg"
          width="688"
          height="334"
          alt="ドレスタイプ診断"
        />
      </div>

      <p className="leading-[18px] text-center mt-5 tracking-[0.05em] sm:text-2xl sm:leading-[36px] sm:mt-10 lg:text-base lg:mt-6 lg:leading-[30px]">
        ドレスタイプ診断で
        <br className="lg:hidden" />
        あなたに似合うドレスのタイプを判定！
        <br />
        あなたにぴったりの最高の1着を見つけよう。
        <br />
        6つのタイプ別にあなたに合う
        <br className="lg:hidden" />
        ドレスのイメージやブランドをご提案します。
      </p>

      <button
        className="mx-auto mt-5 text-white btn-1 bg-custom-5 sm:mt-10 lg:mt-6 lg:border-2 lg:border-custom-5 lg:hover:bg-white lg:hover:text-custom-5 lg:duration-300"
        onClick={start}
      >
        診断スタート
      </button>

      <dl className="relative pb-6 pt-[26px] mt-8 text-center border border-custom-3 sm:mt-16 sm:pt-12 sm:pb-12 lg:max-w-[540px] lg:mx-auto lg:mt-12 lg:pt-9 lg:pb-8">
        <dt className="absolute top-0 px-3 font-medium transform -translate-x-1/2 -translate-y-1/2 bg-white left-1/2 sm:text-2xl sm:px-6 lg:text-base">
          診断結果でわかること
        </dt>
        <div className="inline-block space-y-1 text-left sm:space-y-2 lg:space-y-0">
          <dd className="sm:text-2xl lg:text-sm">
            <span className="mr-2 text-custom-5">■</span>
            あなたに合ったドレスのタイプ
          </dd>
          <dd className="sm:text-2xl lg:text-sm">
            <span className="mr-2 text-custom-5">■</span>ドレスのブランド名
          </dd>
          <dd className="sm:text-2xl lg:text-sm">
            <span className="mr-2 text-custom-5">■</span>取扱店舗
          </dd>
        </div>
      </dl>

      <Share className="mt-6 sm:mt-12 lg:mt-10" />
    </div>
  )
}

export default Top
